import {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
  useCallback,
} from 'react';
import { SocketContext } from '../../context/socket';
import SendVerification from '../../components/sendVerification/SendVerification';
import AdRotator from '../adRotator/AdRotator';
import ReactPlayer from 'react-player/lazy';
import isObjectEmpty from '../../utils/isObjectEmpty';
import { useGetCurrPlayer } from '../../hooks/useGetCurrPlayer';
import { useGetPosts } from '../../hooks/useGetPosts';
import { Chat } from '@material-ui/icons';
import Post from '../post/Post';
import Share from '../share/Share';
import './feed.css';
import axiosConn from '../../axiosConn';
import Friendship from '../friendship/Friendship';
import DynamicHtml from '../dynamicHtml/DynamicHtml';
import { AuthContext } from '../../context/AuthContext';
import { ViewPortContext } from '../../context/ViewPortContext';
import { CircularProgress } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { format } from 'timeago.js';
import MemeRotator from '../memeRotator/MemeRotator';
import getMonthDiff from '../../utils/getMonthDiff';
import MemoryPostRotator from '../memoryPostRotator/MemoryPostRotator';
import useInfiniteScroll from '../../hooks/useInfiniteScroll';
import InstallButton from '../installButton/installButton';
import PwaInstallHelpSheet from '../installButton/PwaInstallHelpSheet';
import usePwaInstallRecovery from '../installButton/usePwaInstallRecovery';
import JGAlertsActivationSheet from '../notifications/JGAlertsActivationSheet';
import useWebPushStatus from '../notifications/useWebPushStatus';
import { useTheme, useThemeUpdate } from '../../context/ThemeContext';
import HappyBirthday from '../happyBirthday/HappyBirthday';
import FeedHighlightsRail from './FeedHighlightsRail';
import BTCRailCard from '../btcTracker/BTCRailCard';
import JGKTopModal from './JGKTopModal';
import LocalCircleSuggestions, {
  useLocalCircleSuggestions,
} from './LocalCircleSuggestions';
import { applyCommentDeleteToItems } from '../../utils/commentRealtime';
import {
  applyPostEditToItems,
  mergeUntrustedPostUpdate,
} from '../../utils/postRealtime';
import LoadedSurfaceSearch, {
  LoadedSurfaceSearchSnippet,
} from '../loadedSurfaceSearch/LoadedSurfaceSearch';
import {
  getSearchableTextForPost,
  isLoadedSurfaceSearchActive,
  normalizeSearchQuery,
} from '../../utils/loadedSurfaceSearch';

const PAGE_SIZE = 20;
const FEED_CONTENT_MODE_STORAGE_KEY = 'jg:feedContentMode:v1';
const FEED_CONTENT_MODES = ['all', 'posts', 'localops'];

const AUDIO_URL =
  'https://res.cloudinary.com/joegalaxy/video/upload/q_auto/v1668752473/korean_sms_cute_ucpzu9.mp3';
const AUDIO_FORMATS = /.(webm|mp3|wav)$/i;
const VIDEO_FORMATS = /.(webm|mp4|mov)$/i;
const IMAGE_FORMATS = /.(jpeg|jpg|gif|png|webp)$/i;

const normalizeFeedContentMode = (value) =>
  FEED_CONTENT_MODES.includes(value) ? value : 'all';

const getInitialFeedContentMode = () => {
  try {
    return normalizeFeedContentMode(
      window.sessionStorage?.getItem(FEED_CONTENT_MODE_STORAGE_KEY),
    );
  } catch {
    return 'all';
  }
};

const isFeedLocalOpsPost = (post) => {
  const context = String(post?.context || '').toLowerCase();
  const meta = post?.meta && typeof post.meta === 'object' ? post.meta : {};
  return (
    context.startsWith('localops') ||
    Boolean(meta.localops || post?.localOps)
  );
};

const shouldIncludePostForContentMode = (post, mode) => {
  const normalizedMode = normalizeFeedContentMode(mode);
  if (normalizedMode === 'posts') return !isFeedLocalOpsPost(post);
  if (normalizedMode === 'localops') return isFeedLocalOpsPost(post);
  return true;
};

// Scroll helpers for stable prepend
const captureScrollMetrics = () => {
  const doc = document.documentElement;
  return {
    top: window.pageYOffset || doc.scrollTop,
    height: doc.scrollHeight,
  };
};
const restoreScrollAfterPrepend = (prevMetrics, threshold = 160) => {
  if (window.scrollY < threshold) return; // Let user see new post if near top
  const doc = document.documentElement;
  const delta = doc.scrollHeight - prevMetrics.height;
  if (delta > 0) {
    window.scrollTo(0, prevMetrics.top + delta);
  }
};

export default function Feed({
  playerId,
  parent = null,
  galaxy = null,
  subscriptionStatus = 'Subscribe',
  isGalaxyMember = false,
}) {
  const isGalaxyFeed = parent === 'galaxy';
  const isMainFeed = !isGalaxyFeed && !playerId;
  const [posts, setPosts] = useState([]);
  const [newPost, setNewPost] = useState({});
  const [isFriend, setIsFriend] = useState(false);
  const audioRef = useRef(null);
  const { player } = useContext(AuthContext);
  const [visitedPlayer, setVisitedPlayer] = useState({});
  const { width } = useContext(ViewPortContext);
  const [friends, setFriends] = useState([]);
  const [myFriends, SetMyFriends] = useState([]);
  const [visitedPlayerIsSet, SetVisitedPlayerIsSet] = useState(false);
  // const { socket: socket2 } = useContext(SocketContext);
  const { socket: socket2 } = useContext(SocketContext);
  const [onlinePlayers, setOnlinePlayers] = useState([]);
  const [myOnlineFriends, SetMyOnlineFriends] = useState([]);
  const [arrivalMessage, setArrivalMessage] = useState(null);
  const [myOnlineFriendThatMessaged, SetMyOnlineFriendThatMessaged] = useState(
    [],
  );
  const [, setConvoId] = useState('');
  const [, setMessageTextIsVideo] = useState(false);
  const [randomNumTwo, setRandomNumTwo] = useState(0);
  const [currPlayer, setCurrPlayer] = useState({});
  const [isAudio, setIsAudio] = useState(false);
  const [isVideo, setIsVideo] = useState(false);
  const [isImage, setIsImage] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const { darkTheme } = useTheme();
  const [sortBy, setSortBy] = useState(0);
  const [page, setPage] = useState(1);
  const [socketPostIds, setSocketPostIds] = useState([]);
  const [trigger, setTrigger] = useState(0);
  const [postItems, setPostItems] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [postSearchQuery, setPostSearchQuery] = useState('');
  const [debouncedPostSearchQuery, setDebouncedPostSearchQuery] = useState('');
  const [postSearchResults, setPostSearchResults] = useState([]);
  const [postSearchLoading, setPostSearchLoading] = useState(false);
  const [postSearchError, setPostSearchError] = useState('');
  const [feedContentMode, setFeedContentMode] = useState(
    getInitialFeedContentMode,
  );
  const [expandedLocalOpsPostId, setExpandedLocalOpsPostId] = useState(null);
  const [showTopModal, setShowTopModal] = useState(false);
  const [leaders, setLeaders] = useState([]);
  const [leadersLoading, setLeadersLoading] = useState(false);
  // Legacy refs kept for backward compatibility (unused in new prepend mode)
  const newPostsRef = useRef([]);
  const newPostsQueueRef = useRef([]);
  const topSentinelRef = useRef(null);
  const localCircleRef = useRef(null);
  const postSearchRequestRef = useRef(0);
  const activeFeedContentMode = isMainFeed
    ? normalizeFeedContentMode(feedContentMode)
    : 'all';
  const usesHomeActionDock = isMainFeed || isGalaxyFeed;
  const installDock = usePwaInstallRecovery('feedDock');
  const alertsDock = useWebPushStatus();
  const [alertsSheetOpen, setAlertsSheetOpen] = useState(false);
  const localCircle = useLocalCircleSuggestions({
    enabled: usesHomeActionDock,
    player,
  });

  const d = new Date();
  const [memoryPostMonths] = useState(
    getMonthDiff(new Date(2022, 2), new Date(d.getFullYear(), d.getMonth())),
  );

  const mountedRef = useRef(false);
  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const mobileView = useMediaQuery({ query: '(max-width: 805px)' });

  const safeSet = useCallback(
    (setter) =>
      (...args) => {
        if (mountedRef.current) setter(...args);
      },
    [],
  );

  useEffect(() => {
    const onFocus = () => {
      if (!mountedRef.current) return;
      setRandomNumTwo(Math.floor(Math.random() * 2));
    };
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, []);

  const onSuccess = () => {};
  const onError = () => {};
  const { data: data2, status: status2 } = useGetCurrPlayer(
    onSuccess,
    onError,
    player,
  );
  useEffect(() => {
    if (status2 === 'success') safeSet(setCurrPlayer)(data2);
  }, [status2, data2, safeSet]);

  useEffect(() => {
    if (!audioRef.current) audioRef.current = new Audio(AUDIO_URL);
  }, []);

  useEffect(() => {
    if (parent === 'galaxy') {
      setPosts([]);
      setPostItems([]);
      setPage(1);
      setTrigger((p) => p + 1);
    }
  }, [isGalaxyMember, parent]);

  // Infinite scroll (down)
  useInfiniteScroll(() => {
    if (hasMore) {
      setPage((p) => p + 1);
    }
  }, 'down');

  // (Optional) up scroll hook retained; no flush needed now
  useInfiniteScroll(() => {}, 'up');

  // Socket presence + message events
  useEffect(() => {
    if (!socket2 || !player?.data?.player?._id) return;
    socket2.emit('addPlayer', player.data.player._id);

    const onPlayers = (players) => {
      if (!mountedRef.current) return;
      setOnlinePlayers(
        player.data.player.followings.filter((f) =>
          players.some((u) => u.playerId === f),
        ),
      );
    };

    const onMessage = (data) => {
      if (!mountedRef.current) return;
      setArrivalMessage({
        sender: data.senderId,
        text: data.text,
        createdAt: Date.now(),
        img: data.img,
      });
      try {
        audioRef.current?.play?.();
      } catch {}
      setIsAudio(AUDIO_FORMATS.test(data?.img));
      setIsVideo(VIDEO_FORMATS.test(data?.img));
      setIsImage(IMAGE_FORMATS.test(data?.img));
    };

    socket2.on('getPlayers', onPlayers);
    socket2.on('getMessage', onMessage);
    return () => {
      socket2.off('getPlayers', onPlayers);
      socket2.off('getMessage', onMessage);
    };
  }, [socket2, player?.data?.player?._id]);

  useEffect(() => {
    SetMyOnlineFriends(myFriends.filter((f) => onlinePlayers.includes(f._id)));
  }, [myFriends, onlinePlayers]);

  useEffect(() => {
    SetMyOnlineFriendThatMessaged(
      myOnlineFriends.filter((f) => f._id === arrivalMessage?.sender),
    );
  }, [arrivalMessage, myOnlineFriends]);

  // Visited player fetch
  useEffect(() => {
    if (!playerId) {
      SetVisitedPlayerIsSet(false);
      return;
    }
    const ac = new AbortController();
    (async () => {
      try {
        const res = await axiosConn.get(`players/?playerId=${playerId}`, {
          headers: { Authorization: `Bearer ${player.token}` },
          signal: ac.signal,
        });
        if (!mountedRef.current) return;
        setVisitedPlayer(res.data.data.data[0]);
        SetVisitedPlayerIsSet(true);
      } catch {
        if (!ac.signal.aborted) SetVisitedPlayerIsSet(false);
      }
    })();
    return () => ac.abort();
  }, [playerId, player.token]);

  // Visited player's friends
  useEffect(() => {
    if (!visitedPlayerIsSet || !visitedPlayer?._id) return;
    const ac = new AbortController();
    (async () => {
      try {
        const { data } = await axiosConn.get(
          `players/friends/${visitedPlayer._id}`,
          {
            headers: { Authorization: `Bearer ${player.token}` },
            signal: ac.signal,
          },
        );
        if (!mountedRef.current || ac.signal.aborted) return;
        const raw = Array.isArray(data)
          ? data
          : Array.isArray(data?.friends)
          ? data.friends
          : [];
        const safeFriends = raw.filter((f) => f && f._id);
        if (safeFriends.length !== raw.length) {
          console.warn('[Feed] filtered stale/null friends (visited)', {
            requested: raw.length,
            kept: safeFriends.length,
          });
        }
        setFriends(safeFriends);
      } catch {}
    })();
    return () => ac.abort();
  }, [visitedPlayerIsSet, visitedPlayer?._id, player.token]);

  // My friends
  useEffect(() => {
    const ac = new AbortController();
    (async () => {
      try {
        if (!player?.data?.player?._id) return;
        const { data } = await axiosConn.get(
          `players/friends/${player.data.player._id}`,
          {
            headers: { Authorization: `Bearer ${player.token}` },
            signal: ac.signal,
          },
        );
        if (!mountedRef.current || ac.signal.aborted) return;
        const raw = Array.isArray(data)
          ? data
          : Array.isArray(data?.friends)
          ? data.friends
          : [];
        const safeFriends = raw.filter((f) => f && f._id);
        if (safeFriends.length !== raw.length) {
          console.warn('[Feed] filtered stale/null friends (self)', {
            requested: raw.length,
            kept: safeFriends.length,
          });
        }
        SetMyFriends(safeFriends);
      } catch {}
    })();
    return () => ac.abort();
  }, [player?.data?.player?._id, player.token]);

  // Friendship status
  useEffect(() => {
    if (!playerId) return;
    const ac = new AbortController();
    (async () => {
      try {
        const res1 = await axiosConn.get(`players/?playerId=${playerId}`, {
          headers: { Authorization: `Bearer ${player.token}` },
          signal: ac.signal,
        });
        if (!mountedRef.current || ac.signal.aborted) return;
        setIsFriend(
          res1.data.data.data[0]?.friends.includes(player.data.player._id),
        );
      } catch {}
    })();
    return () => ac.abort();
  }, [playerId, player.data.player._id, player.token]);

  useEffect(() => {
    setPage(1);
    setPostItems([]);
    setHasMore(true);
    setExpandedLocalOpsPostId(null);
  }, [playerId, activeFeedContentMode]);

  const { isLoading, data, status } = useGetPosts(
    onSuccess,
    onError,
    player,
    playerId,
    page,
    parent === 'galaxy' ? 'galaxyPosts' : 'posts',
    parent === 'galaxy' ? galaxy?._id : null,
    false, // friends/own timeline only; do not use location-based feed here
    null,
    'mi',
    null,
    null,
    activeFeedContentMode,
  );

  // Merge paginated fetch
  useEffect(() => {
    if (status !== 'success' || !Array.isArray(data) || !data.length) return;
    const modeAtMerge = activeFeedContentMode;
    const visibleData = data.filter((post) =>
      shouldIncludePostForContentMode(post, modeAtMerge),
    );
    setPostItems((prev) => {
      const existing = new Set(prev.map((p) => p._id));
      const fromSockets = new Set(socketPostIds);
      const add = visibleData.filter(
        (p) => !existing.has(p._id) && !fromSockets.has(p._id),
      );
      if (!add.length) return prev;
      return [...prev, ...add].sort((a, b) => {
        const A = a.repostedAt ? new Date(a.repostedAt) : new Date(a.createdAt);
        const B = b.repostedAt ? new Date(b.repostedAt) : new Date(b.createdAt);
        return B - A;
      });
    });
    if (Array.isArray(data) && data.length < PAGE_SIZE) {
      setHasMore(false);
    }
  }, [status, data, socketPostIds, activeFeedContentMode]);

  // Ranking / newest sorting (legacy path)
  const handleSortTopRanked = () => {
    setPosts((prev) =>
      [...prev].sort(
        (a, b) =>
          b.likes.length * 2 +
          b.comments.length * 4 +
          b.views * 0.25 +
          (b.rePosts.length + b.reShares.length) * 20 +
          b.jgkTokens -
          (a.likes.length * 2 +
            a.comments.length * 4 +
            a.views * 0.25 +
            (a.rePosts.length + a.reShares.length) * 20 +
            a.jgkTokens),
      ),
    );
    setSortBy(1);
  };
  const handleSortNewest = () => {
    if (!Array.isArray(posts)) return;
    setPosts((prev) =>
      [...prev].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)),
    );
    setSortBy(0);
  };

  useEffect(() => {
    if (!isObjectEmpty(newPost)) {
      setPosts((prev) => [...prev, newPost]);
    }
  }, [newPost]);

  useEffect(() => {
    handleSortNewest();
  }, [posts.length]);

  // Socket: prepend new posts with scroll compensation
  useEffect(() => {
    if (!socket2 || !player?.data?.player?.playerId) return;
    const onPost = (post) => {
      if (!post?._id) return;
      setSocketPostIds((prev) =>
        prev.includes(post._id) ? prev : [...prev, post._id],
      );

      const isSelf = post.playerId === player.data.player.playerId;
      const isFriend = myFriends?.some((f) => f.playerId === post.playerId);

      if (
        (isSelf || isFriend) &&
        shouldIncludePostForContentMode(post, activeFeedContentMode)
      ) {
        setPostItems((prev) => {
          if (prev.some((p) => p._id === post._id)) return prev;
          const metrics = captureScrollMetrics();
          const next = [post, ...prev].sort((a, b) => {
            const A = a.repostedAt
              ? new Date(a.repostedAt)
              : new Date(a.createdAt);
            const B = b.repostedAt
              ? new Date(b.repostedAt)
              : new Date(b.createdAt);
            return B - A;
          });
          requestAnimationFrame(() => restoreScrollAfterPrepend(metrics));
          return next;
        });
      }
    };
    socket2.on('getPost', onPost);
    return () => socket2.off('getPost', onPost);
  }, [socket2, myFriends, player?.data?.player?.playerId, activeFeedContentMode]);

  // NEW: reflect creator's new post in rendered list immediately
  useEffect(() => {
    if (isObjectEmpty(newPost) || !newPost._id) return;
    // Mark so later socket echo / pagination won't duplicate
    setSocketPostIds((prev) =>
      prev.includes(newPost._id) ? prev : [...prev, newPost._id],
    );
    setPostItems((prev) => {
      if (prev.some((p) => p._id === newPost._id)) return prev;
      const metrics = captureScrollMetrics();
      const next = [newPost, ...prev].sort((a, b) => {
        const A = a.repostedAt ? new Date(a.repostedAt) : new Date(a.createdAt);
        const B = b.repostedAt ? new Date(b.repostedAt) : new Date(b.createdAt);
        return B - A;
      });
      requestAnimationFrame(() => restoreScrollAfterPrepend(metrics));
      return next;
    });
  }, [newPost]);

  // Socket: updates
  useEffect(() => {
    if (!socket2) return;
    const onUpdate = (updatedPost) => {
      if (!updatedPost?._id) return;
      setPostItems((prev) =>
        prev.map((p) =>
          String(p._id || '') === String(updatedPost._id || '')
            ? mergeUntrustedPostUpdate(p, updatedPost)
            : p,
        ),
      );
      setPostSearchResults((prev) =>
        prev.map((p) =>
          String(p._id || '') === String(updatedPost._id || '')
            ? mergeUntrustedPostUpdate(p, updatedPost)
            : p,
        ),
      );
    };
    const onPostEdited = (payload) => {
      setPostItems((prev) => applyPostEditToItems(prev, payload));
      setPostSearchResults((prev) => applyPostEditToItems(prev, payload));
    };
    socket2.on('getPostUpdates', onUpdate);
    socket2.on('post:edited', onPostEdited);
    return () => {
      socket2.off('getPostUpdates', onUpdate);
      socket2.off('post:edited', onPostEdited);
    };
  }, [socket2]);

  // Socket: comments updates
  useEffect(() => {
    if (!socket2) return;
    const onCommentUpdate = ({ postId, comments }) => {
      if (!postId) return;
      setPostItems((prev) =>
        prev.map((p) =>
          String(p._id || '') === String(postId || '') ? { ...p, comments } : p,
        ),
      );
      setPostSearchResults((prev) =>
        prev.map((p) =>
          String(p._id || '') === String(postId || '') ? { ...p, comments } : p,
        ),
      );
    };
    const onCommentDeleted = (payload) => {
      setPostItems((prev) =>
        applyCommentDeleteToItems(prev, payload, 'postId'),
      );
      setPostSearchResults((prev) =>
        applyCommentDeleteToItems(prev, payload, 'postId'),
      );
    };
    socket2.on('getPostCommentsUpdates', onCommentUpdate);
    socket2.on('post:comment:deleted', onCommentDeleted);
    return () => {
      socket2.off('getPostCommentsUpdates', onCommentUpdate);
      socket2.off('post:comment:deleted', onCommentDeleted);
    };
  }, [socket2]);

  // Socket: remove post
  useEffect(() => {
    if (!socket2) return;
    const onRemove = (post) => {
      if (!post?._id) return;
      setSocketPostIds((prev) => prev.filter((id) => id !== post._id));
      setPostItems((prev) => prev.filter((p) => p._id !== post._id));
      setPostSearchResults((prev) => prev.filter((p) => p._id !== post._id));
      newPostsRef.current = newPostsRef.current.filter(
        (p) => p._id !== post._id,
      );
      newPostsQueueRef.current = newPostsQueueRef.current.filter(
        (p) => p._id !== post._id,
      );
    };
    socket2.on('removePost', onRemove);
    return () => socket2.off('removePost', onRemove);
  }, [socket2]);

  const goToMessenger = (cId) => {
    setConvoId(cId);
    window.location.href = `/messenger/${cId || "''"}`;
  };

  const getConversationGoToMessenger = async () => {
    if (!myOnlineFriendThatMessaged[0]?._id) return goToMessenger("''");
    try {
      const res = await axiosConn.get(
        `conversations/find/${player.data.player._id}/${myOnlineFriendThatMessaged[0]._id}`,
        { headers: { Authorization: `Bearer ${player.token}` } },
      );
      goToMessenger(res.data?._id);
    } catch {
      goToMessenger("''");
    }
  };

  const handleDeletePost = (postId) => {
    setPostItems((prev) => prev.filter((p) => p._id !== postId));
    setPostSearchResults((prev) => prev.filter((p) => p._id !== postId));
  };

  const handleUpdatePost = (updatedPost) => {
    if (!updatedPost?._id) return;
    setPostItems((prev) =>
      prev.map((p) =>
        String(p._id || '') === String(updatedPost._id || '') ? updatedPost : p,
      ),
    );
    setPostSearchResults((prev) =>
      prev.map((p) =>
        String(p._id || '') === String(updatedPost._id || '') ? updatedPost : p,
      ),
    );
  };

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setDebouncedPostSearchQuery(postSearchQuery);
    }, 300);

    return () => window.clearTimeout(timer);
  }, [postSearchQuery]);

  const clearPostSearch = useCallback(() => {
    setPostSearchQuery('');
    setDebouncedPostSearchQuery('');
    setPostSearchResults([]);
    setPostSearchError('');
    setPostSearchLoading(false);
    postSearchRequestRef.current += 1;
  }, []);

  const selectFeedContentMode = useCallback(
    (mode) => {
      const nextMode = normalizeFeedContentMode(mode);
      setFeedContentMode(nextMode);
      setExpandedLocalOpsPostId(null);
      try {
        window.sessionStorage?.setItem(
          FEED_CONTENT_MODE_STORAGE_KEY,
          nextMode,
        );
      } catch {}
    },
    [],
  );

  const postSearchActive = isLoadedSurfaceSearchActive(
    debouncedPostSearchQuery,
  );
  const normalizedPostSearchQuery = normalizeSearchQuery(
    debouncedPostSearchQuery,
  );

  useEffect(() => {
    if (!postSearchActive || !player?.token) {
      setPostSearchResults([]);
      setPostSearchLoading(false);
      setPostSearchError('');
      return undefined;
    }

    const requestId = postSearchRequestRef.current + 1;
    postSearchRequestRef.current = requestId;
    setPostSearchLoading(true);
    setPostSearchError('');

    axiosConn
      .get('posts/search', {
        params: {
          q: normalizedPostSearchQuery,
          ...(activeFeedContentMode !== 'all'
            ? { contentMode: activeFeedContentMode }
            : {}),
        },
        headers: {
          Authorization: `Bearer ${player.token}`,
        },
      })
      .then((res) => {
        if (postSearchRequestRef.current !== requestId) return;
        const posts = Array.isArray(res?.data?.data?.posts)
          ? res.data.data.posts
          : [];
        setPostSearchResults(posts);
      })
      .catch(() => {
        if (postSearchRequestRef.current !== requestId) return;
        setPostSearchResults([]);
        setPostSearchError('Post search is unavailable. Your feed is unchanged.');
      })
      .finally(() => {
        if (postSearchRequestRef.current === requestId) {
          setPostSearchLoading(false);
        }
      });

    return undefined;
  }, [
    normalizedPostSearchQuery,
    player?.token,
    postSearchActive,
    activeFeedContentMode,
  ]);

  const showingPostSearchResults = postSearchActive && !postSearchError;
  const renderedPostItems = showingPostSearchResults
    ? postSearchResults
    : postItems;
  const canRenderPostItems =
    (parent !== 'galaxy' &&
      (isFriend || !playerId || playerId === player.data.player.playerId)) ||
    (parent === 'galaxy' && isGalaxyMember) ||
    subscriptionStatus === 'Subscribed';

  const openLeaders = async () => {
    try {
      setLeadersLoading(true);
      const res = await axiosConn.get('players/?sort=-jgkTokens', {
        headers: { Authorization: `Bearer ${player?.token}` },
      });
      const list = Array.isArray(res?.data?.data?.data)
        ? res.data.data.data
        : [];
      const EXCLUDED_PLAYER_IDS = new Set([
        'secondDayOut',
        'infoJG',
        'newrockstar',
        'stester',
        'rockstarJG',
        'thirdDayDayOut',
        'firstDayOut',
        'jgktokenKing',
        'btester',
        'jgtesterone',
        'winninghands',
        'InterfaceOne',
        'coachCarlosThree',
        'FredSanFord',
        'supportNET',
        'jgdotnet',
      ]);
      const now = Date.now();
      const THIRTY_DAYS = 30 * 24 * 60 * 60 * 1000;
      const filtered = list.filter((p) => {
        if (!p || !p.playerId) return false;
        if (EXCLUDED_PLAYER_IDS.has(p.playerId)) return false;
        const lastVisit = p.lastVisit ? new Date(p.lastVisit).getTime() : 0;
        if (!Number.isFinite(lastVisit)) return false;
        return now - lastVisit <= THIRTY_DAYS;
      });
      setLeaders(filtered.slice(0, 10));
    } catch (err) {
      setLeaders([]);
    } finally {
      setLeadersLoading(false);
      setShowTopModal(true);
    }
  };

  const openLocalCircle = () => {
    localCircle.open();
    window.setTimeout(() => {
      localCircleRef.current?.scrollIntoView?.({
        behavior: 'smooth',
        block: 'center',
      });
    }, 0);
  };

  const postComponents = renderedPostItems
    ?.slice(
      0,
      showingPostSearchResults ? renderedPostItems.length : page * PAGE_SIZE,
    )
    .map((p) => {
      const isLocalOpsPost = isFeedLocalOpsPost(p);
      const isAllModeCompactLocalOps =
        isMainFeed && activeFeedContentMode === 'all' && isLocalOpsPost;
      const isExpanded =
        isAllModeCompactLocalOps &&
        String(expandedLocalOpsPostId || '') === String(p._id || '');
      const localOpsPresentation = isAllModeCompactLocalOps
        ? isExpanded
          ? 'feedExpanded'
          : 'feedCompact'
        : isMainFeed &&
          activeFeedContentMode === 'localops' &&
          isLocalOpsPost
        ? 'localOpsMode'
        : 'default';

      return (
        <Fragment key={p._id}>
          {showingPostSearchResults && (
            <LoadedSurfaceSearchSnippet
              text={getSearchableTextForPost(p)}
              query={normalizedPostSearchQuery}
            />
          )}
          <Post
            galaxy={galaxy}
            initialPost={p}
            localOpsExpanded={isExpanded}
            localOpsPresentation={localOpsPresentation}
            onDelete={handleDeletePost}
            onLocalOpsToggle={() =>
              setExpandedLocalOpsPostId((current) =>
                String(current || '') === String(p._id || '') ? null : p._id,
              )
            }
            onUpdate={handleUpdatePost}
          />
        </Fragment>
      );
    });

  return (
    <div className={darkTheme ? 'app feed dark-theme' : 'app feed'}>
        <div className="feedWrapperFeed">
          <InstallButton suppressCompactPrompt={usesHomeActionDock} />

          <div ref={topSentinelRef} style={{ height: 1 }} />

          {usesHomeActionDock && (
            <LocalCircleSuggestions ref={localCircleRef} state={localCircle} />
          )}

            {parent !== 'galaxy' && (
              <FeedHighlightsRail
                showMeme={false}
                showBtc={false}
              />
            )}

            <LoadedSurfaceSearch
              value={postSearchQuery}
              onChange={setPostSearchQuery}
              onClear={clearPostSearch}
              placeholder="Search posts..."
              ariaLabel="Search posts"
              clearLabel="Clear post search"
              helperText="Searches posts you're allowed to see."
              isActive={postSearchActive}
              resultCount={postSearchResults.length}
              statusText={
                postSearchLoading
                  ? 'Searching posts...'
                  : postSearchError || undefined
              }
            />

            {isMainFeed && (
              <div className="feedContentModeTabs" aria-label="Feed content">
                {[
                  ['all', 'All'],
                  ['posts', 'Posts'],
                  ['localops', 'LocalOps'],
                ].map(([mode, label]) => (
                  <button
                    key={mode}
                    type="button"
                    className={
                      activeFeedContentMode === mode
                        ? 'feedContentModeButton feedContentModeButton--active'
                        : 'feedContentModeButton'
                    }
                    aria-pressed={activeFeedContentMode === mode}
                    onClick={() => selectFeedContentMode(mode)}
                  >
                    {label}
                  </button>
                ))}
              </div>
            )}

          {width <= 979 && parent !== 'galaxy' && (
            <>
              <div className="feedFriendCount">
                {friends?.length
                  ? friends.length === 1
                  ? '1 Friend'
                  : `${friends.length} Friends`
                  : ''}
              </div>
              <div className="centerWrapper">
                <div className="feedFriendImgs">
                  {friends
                    ?.slice()
                    .sort((a, b) => b.jgkTokens - a.jgkTokens)
                    .map((friend, i) => (
                      <Link
                        to={`/profile/${friend.playerId}`}
                        key={friend._id || i}
                        style={{ zIndex: i, margin: '1px' }}
                      >
                        <img
                          src={
                            friend.profilePhoto ||
                            'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png'
                          }
                          alt=""
                        />
                      </Link>
                    ))}
                </div>
              </div>
              {status === 'success' && postItems.length === 0 && (
                <div className="feed-empty-hint">
                  <Chat style={{ fontSize: 18 }} />
                  {localCircle.hasSuggestions
                    ? 'Add locals to see more posts.'
                    : 'Add friends to see posts.'}
                </div>
              )}
            </>
          )}

        <div className="friendshipFeed">
          {width <= 979 &&
            playerId !== player.data.player.playerId &&
            visitedPlayer && (
              <Friendship
                player1={visitedPlayer}
                subscriptionStatus={subscriptionStatus}
              />
            )}
        </div>

        {/* Legacy online friends strip hidden now that OrbitingFriends replaces it */}
        {false && parent !== 'galaxy' && (
          <div className="feedFriendImgs">
            {myOnlineFriends.slice(0, 6).map((f, i) => (
              <Link to={`/profile/${f.playerId}`} key={f._id || i}>
                <div
                  className="feedChatOnlineImgContainer"
                  style={{
                    transform: `translateX(${-i * 6}px)`,
                    zIndex: i,
                    position: 'relative',
                  }}
                >
                  <img
                    src={
                      f.profilePhoto ||
                      'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png'
                    }
                    alt=""
                  />
                  <div
                    className={
                      !mobileView
                        ? 'feedChatOnlineBadge'
                        : 'feedChatOnlineBadgeMobile'
                    }
                    style={{ position: 'absolute', bottom: 0, right: 3 }}
                  ></div>
                </div>
              </Link>
            ))}
          </div>
        )}

        {myOnlineFriends &&
          arrivalMessage &&
          myOnlineFriendThatMessaged &&
          parent !== 'galaxy' && (
            <>
              {(isAudio || isVideo) && (
                <div className="audioDiv">
                  <ReactPlayer
                    width="72%"
                    height="75%"
                    playing
                    controls
                    url={arrivalMessage.img?.replace('webm', 'mp4')}
                    config={{
                      file: {
                        attributes: {
                          onContextMenu: (e) => e.preventDefault(),
                        },
                      },
                    }}
                  />
                </div>
              )}
              {isImage && (
                <img
                  className="messageImg2 loadingImg"
                  src={arrivalMessage?.img}
                  alt=""
                  loading="lazy"
                  style={{
                    backgroundImage:
                      'url("https://res.cloudinary.com/joegalaxy/image/upload/v1672717524/loading-gif_sfv2dl.gif")',
                  }}
                />
              )}
              <div className="feedFriendImgs2">
                <Link
                  to={
                    myOnlineFriendThatMessaged[0]
                      ? `/profile/${myOnlineFriendThatMessaged[0]?.playerId}`
                      : '/'
                  }
                >
                  <div className="feedChatOnlineImgContainer">
                    <img
                      className="messageImg messageImgTransform"
                      src={
                        myOnlineFriendThatMessaged[0]?.profilePhoto ||
                        'https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1656194537/Images/noAvatar_tsgpm9.png'
                      }
                      alt=""
                    />
                    {onlinePlayers?.includes(
                      myOnlineFriendThatMessaged[0]?._id,
                    ) && (
                      <div
                        className={
                          !mobileView
                            ? 'feedChatOnlineBadgeMsg  messageImgTransform'
                            : 'feedChatOnlineBadgeMobileMsg messageImgTransform'
                        }
                      ></div>
                    )}
                  </div>
                </Link>
                {arrivalMessage?.text && (
                  <div className="feedOnlineFriendMsg">
                    <DynamicHtml
                      from="feed"
                      text={arrivalMessage.text}
                      setMessageTextIsVideo={setMessageTextIsVideo}
                      receiverProfilePhoto={
                        myOnlineFriendThatMessaged[0]?.profilePhoto
                      }
                    />
                  </div>
                )}
                <div
                  className={
                    !mobileView ? 'messageBottom' : 'messageBottomMobile'
                  }
                >
                  {format(arrivalMessage.createdAt)}
                </div>
                <div className="feedChatOnlineImgContainer">
                  <div className="mmenu_main hover3">
                    <Chat
                      fontSize="medium"
                      onClick={getConversationGoToMessenger}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                </div>
              </div>
            </>
          )}

        <HappyBirthday />

        {currPlayer?.verified === false && (
          <SendVerification player={currPlayer || player.data.player} />
        )}

        {parent !== 'galaxy' && (
          <>
            {currPlayer?.jgkTokens < 1000 && mobileView ? (
              <AdRotator surfaceKey="feed" />
            ) : (
              randomNumTwo === 1 && mobileView && <AdRotator surfaceKey="feed" />
            )}
          </>
        )}

        {parent === 'galaxy' && showForm && (
          <Share
            parent={parent}
            galaxyId={galaxy?._id}
            setNewPost={setNewPost}
            isGalaxyMember={galaxy?.members.includes(player.data.player._id)}
            subscriptionStatus={subscriptionStatus}
          />
        )}
        {parent === null && playerId === undefined && showForm && (
          <Share
            parent={parent}
            galaxyId={galaxy?._id}
            setNewPost={setNewPost}
            isGalaxyMember={galaxy?.members.includes(player.data.player._id)}
            subscriptionStatus={subscriptionStatus}
          />
        )}

        {isLoading ? (
          <div className="feedPostProgress">
            <CircularProgress color="inherit" size="10px" />
          </div>
        ) : parent !== 'galaxy' ? (
          <MemoryPostRotator />
        ) : parent !== 'galaxy' && randomNumTwo === 1 ? (
          <>
            <div>
              <h4 className="postTitleThrowback">Meme Machine</h4>
            </div>
            <MemeRotator />
          </>
        ) : null}

        {!isLoading &&
          canRenderPostItems &&
          showingPostSearchResults &&
          !postSearchLoading &&
          postSearchResults.length === 0 && (
            <div className="loadedSurfaceSearchEmpty">
              No posts match '{normalizedPostSearchQuery}'.
            </div>
          )}

        {isLoading ? (
          <div className="feedPostProgress">
            <CircularProgress color="inherit" size="10px" />
          </div>
        ) : (
          canRenderPostItems && postComponents
        )}

        {usesHomeActionDock && (
          <div
            className={
              isGalaxyFeed
                ? 'feedActionDock feedActionDock--galaxy'
                : 'feedActionDock'
            }
          >
            <button
              type="button"
              className="feedActionDockSecondary"
              onClick={openLeaders}
            >
              JGK Top 10
            </button>
            <div className="feedActionDockSecondary feedActionDockSecondary--btc">
              <BTCRailCard variant="dock" />
            </div>
            {usesHomeActionDock && localCircle.hasSuggestions && (
              <button
                type="button"
                className="feedActionDockSecondary feedActionDockSecondary--locals"
                onClick={openLocalCircle}
              >
                Locals
              </button>
            )}
            {usesHomeActionDock && installDock.showCompactPrompt && (
              <button
                type="button"
                className="feedActionDockSecondary feedActionDockSecondary--app"
                onClick={installDock.openHelpSheet}
              >
                App
              </button>
            )}
            {usesHomeActionDock &&
              installDock.isStandalone &&
              alertsDock.hydrated &&
              !alertsDock.subscribed && (
                <button
                  type="button"
                  className="feedActionDockSecondary feedActionDockSecondary--alerts"
                  onClick={() => setAlertsSheetOpen(true)}
                >
                  Alerts
                </button>
              )}
            <button
              type="button"
              className="feedActionDockPrimary"
              onClick={() => setShowForm((s) => !s)}
            >
              {showForm ? 'Close' : '+ Post'}
            </button>
          </div>
        )}

        <JGKTopModal
          open={showTopModal}
          onClose={() => setShowTopModal(false)}
          leaders={leaders}
          loading={leadersLoading}
        />
        {usesHomeActionDock && (
          <PwaInstallHelpSheet
            canNativeInstall={installDock.canNativeInstall}
            nativePromptDismissed={installDock.nativePromptDismissed}
            onClose={installDock.closeHelpSheet}
            onInstall={installDock.promptNativeInstall}
            open={installDock.isSheetOpenForOwner}
            platform={installDock.platform}
          />
        )}
        {usesHomeActionDock && (
          <JGAlertsActivationSheet
            context="connect"
            jwt={player?.token}
            onClose={() => setAlertsSheetOpen(false)}
            onStateChange={alertsDock.refresh}
            onSubscribed={alertsDock.refresh}
            open={alertsSheetOpen}
            status={alertsDock}
            vapidKey={process.env.REACT_APP_VAPID_PUBLIC_KEY}
          />
        )}
      </div>
    </div>
  );
}
